module.exports = __webpack_public_path__ + "static/media/turbocharger-mr-card-front.da769b46.jpeg";